export default async function GetWorkOrder(id = 0, projectId = 0) {
    let url = "";
    if (id === 0 && projectId === 0) {
        url = window.RealestateService + `/api/WorkOrder/GetWorkOrder`;
    }
    else {
        url = window.RealestateService + `/api/WorkOrder/GetWorkOrder?id=${id}&projectId=${projectId}`
    }
    let head = {
        "content-type": "application/json",
        "accept": "*/*",
        "Authorization": window.token
    }
    let response = await fetch(url, {
        method: "GET",
        headers: head,
        // body:JSON.stringify(sendForm)
    }).then(res => res.json()).catch(res => res)

    return response
}